module.exports = __webpack_public_path__ + "files/1d8e10387f9227d533b1aadabef6f8f7.png";


//////////////////
// WEBPACK FOOTER
// ./images/emoji-sheets/travel_places-1.png
// module id = 512
// module chunks = 76